// Meta Pixel (browser). The base code + init + first PageView live in public/index.html so the
// pixel loads exactly once; this module only sends events through window.fbq.
export const META_PIXEL_ID = "1106484555105022";
export const PRODUCT_CONTENT = { content_name: "My Christmas", content_type: "product", content_ids: ["MYCHRISTMAS2026"] };

const PURCHASE_KEY = "mc_fb_purchase_";

function fbq(...args) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return false;
  try { window.fbq(...args); return true; } catch { return false; }
}

// SPA route change. index.html records the path of the initial PageView in window.__mcPixelLastPath.
export function trackPageView(pathname) {
  if (typeof window === "undefined") return;
  if (window.__mcPixelLastPath === pathname) return;
  window.__mcPixelLastPath = pathname;
  fbq("track", "PageView");
}

// Fired only when the user is actually being redirected to the checkout.
export function trackInitiateCheckout({ value, currency }) {
  const params = { ...PRODUCT_CONTENT, num_items: 1 };
  if (value != null && currency) { params.value = Number(value); params.currency = currency; }
  fbq("track", "InitiateCheckout", params);
}

// Stable per-transaction id shared with the future Conversions API (same eventID => Meta dedups browser+server).
export const purchaseEventId = (ref) => `purchase_${ref}`;

// Purchase: only after the backend confirmed an approved, webhook-granted entitlement.
// `purchase` = { ref, value, currency } returned by POST /api/payments/status. Fires once per ref per browser.
export function trackPurchase(purchase) {
  if (!purchase?.ref) return false;
  const key = PURCHASE_KEY + purchase.ref;
  try { if (localStorage.getItem(key)) return false; } catch { /* storage unavailable: still fire once per page load */ }
  const params = { ...PRODUCT_CONTENT, num_items: 1 };
  if (purchase.value != null && purchase.currency) { params.value = Number(purchase.value); params.currency = purchase.currency; }
  const sent = fbq("track", "Purchase", params, { eventID: purchaseEventId(purchase.ref) });
  try { localStorage.setItem(key, new Date().toISOString()); } catch { /* ignore */ }
  return sent;
}
